import RevertDefault from '../../blocks/revert-default/revert-default';

const LANDING_URL = 'install/hub/verify';
const ENTER_KEY = 13;

export default class HubSettingsController {
  /*@ngInject*/
  constructor($scope, $window, $q, $location, installerResource, fields, hubAuthPopup,
    hubResource, wizardInfo, i18n, hubCredentialsFormPopup, urlHelper, sslCertificateDialog) {
    this.$scope = $scope;
    this.$window = $window;
    this.fields = fields;
    this.installerResource = installerResource;
    this.$location = $location;
    this.$q = $q;
    this.i18n = i18n;
    this.wizardInfo = wizardInfo;
    this.hubAuthPopup = hubAuthPopup;
    this.urlHelper = urlHelper;
    this.sslCertificateDialog = sslCertificateDialog;
    this.HubResourceFactory = hubResource;
    this.hubCredentialsFormPopup = hubCredentialsFormPopup;
    this.revertDefault = {};
    this.welcomePageAvailable = wizardInfo.isUpgradeAvailable;

    //Is external hub verified
    this.isVerified = false;
    this.hubHomeUrl = null;
    this.hubHomeUrlIsAvailable = null;

    this.hubSettings = installerResource.getSingletonOf('hubSettings');

    this.defaultSettingsResource = installerResource.hubSettingsDefault.get();

    $q.all([this.hubSettings.$promise, this.defaultSettingsResource.$promise]).then(() => {
      this.revertDefault = new RevertDefault(this.hubSettings, this.defaultSettingsResource);
    }, () => {
      installerResource.clearSingletonOf('hubSettings');
    });
  }

  nextStep() {
    this.fixHubSettingsInconsistency(this.hubSettings);

    this.hubSettings.$save().
      then(() => this.$location.url('install/license')).
      catch(response => {
        if (response) {
          this.errors = this.installerResource.extractErrorMessage(response.data);
        }
      });
  }

  isNotCompleted() {
    return this.$scope.hubSettings.$invalid ||
      (!this.isInternalHub() && !this.isVerified);
  }

  isExternalHubPermitted() {
    return this.wizardInfo[this.fields.IS_EXTERNAL_HUB_PERMITTED];
  }

  isInternalHub() {
    return !this.hubSettings[this.fields.DISABLE_INTERNAL_HUB] || !this.isExternalHubPermitted();
  }

  resetToDefault() {
    this.revertDefault.revertToDefault();
    delete this.hubSettings[this.fields.ROOT_PASSWORD];
    delete this.hubSettings[this.fields.HUB_URL];
    this.confirmPassword = null;
    this.errors = {};
  }

  getAdminTitle() {
    const adminName = this.i18n('Admin');

    return adminName;
  }

  fixHubSettingsInconsistency(res) {
    //Force externalHub flag if external is not permitted
    if (!this.isExternalHubPermitted()) {
      res[this.fields.DISABLE_INTERNAL_HUB] = false;
    }
  }

  onUrlKeyPress($event) {
    if ($event.which === ENTER_KEY) {
      if (this.isVerified) {
        if (!this.isNotCompleted()) {
          this.nextStep();
        }
      } else {
        this.verifyHub();
      }
      $event.preventDefault();
    }
  }

  onHubFormKeyPress($event) {
    if ($event.which === ENTER_KEY && !this.isNotCompleted()) {
      this.nextStep();
    }
  }

  toggleDisableInternalHub(disabled) {
    this.hubSettings[this.fields.DISABLE_INTERNAL_HUB] = disabled;
    // Hack around BND-847
    if (!disabled) {
      delete this.hubSettings[this.fields.HUB_URL];
    }
  }

  isVerifyWarning() {
    return !this.hubHomeUrl || !this.hubHomeUrlIsAvailable;
  }

  isShowVerify() {
    return this.isVerifyWarning() || !this.isVerified;
  }

  isEnabledAllowAnonymousAccess() {
    return this.hubSettings.isAllowAnonymousAccessEditable;
  }

  getErrorMessage(field) {
    if (this.errors) {
      const error = this.errors[field];
      return error ? error.error_description : error;
    }
  }


  /**
   * Fallback for hub with banned quest
   */
  verifyHubWithCredentials(hubStateResource, error) {
    const hubUrl = this.hubSettings[this.fields.HUB_URL];

    const loginAction = result => {
      hubStateResource[this.fields.HUB_URL] = hubUrl;
      return hubStateResource.$save({
        redirectUri: `${this.$window.location.origin }/${ LANDING_URL}`,
        login: result.login,
        password: result.password
      });
    };

    return this.hubCredentialsFormPopup(error.error_description, null, loginAction);
  }

  confirmUntrustedSsl(error) {
    return this.sslCertificateDialog(error.data.additionalInfo).
      catch(() => this.$q.reject(error));
  }

  /**
   * Verifying hub by authorize in separated window
   */
  verifyHub() {
    const fixedUrl = this.urlHelper.addProtocolIfNotExist(this.hubSettings[this.fields.HUB_URL]);

    this.hubError = null;
    this.hubSettings[this.fields.HUB_URL] = fixedUrl;

    let hubUrl = this.hubSettings[this.fields.HUB_URL];

    // create and post bundle service
    // eslint-disable-next-line new-cap
    const hubStateResource = new this.installerResource.bundleService();
    hubStateResource[this.fields.HUB_URL] = hubUrl;
    hubStateResource.$save({redirectUri: `${this.$window.location.origin }/${ LANDING_URL}`}).
      catch(errResponse => {
        errResponse.data.errors = this.installerResource.extractErrorMessage(errResponse.data);
        // eslint-disable-next-line guard-for-in
        for (const key in errResponse.data.errors) {
          errResponse.data.errors[key] = errResponse.data.errors[key].error_description;
        }
        return this.$q.reject(errResponse);
      }).
      catch(result => {
        // eslint-disable-next-line no-shadow
        const handleAndRepeatRequestErrors = result => {
          this.authWithCredentials = false;
          if (result.status === 403) {
            this.authWithCredentials = true;
            return this.verifyHubWithCredentials(hubStateResource, {
              data: result.data.error
            }).catch(err => {
              const errors = this.installerResource.extractErrorMessage(err.data);
              return this.$q.reject(errors && errors.hubUrl && errors.hubUrl.error_description || errors);
            });
          } else if (result.status === 400 && result.data.additionalInfo && result.data.additionalInfo.untrustedCertificate) {
            return this.confirmUntrustedSsl({data: result.data}).
              then(() => hubStateResource.$save({
                redirectUri: `${this.$window.location.origin }/${ LANDING_URL}`
              }));
          }
          return this.$q.reject((result.data && result.data.errors && result.data.errors.hubUrl) || result.message || result);
        };

        return handleAndRepeatRequestErrors(result).catch(err => handleAndRepeatRequestErrors(err));
      }).


    /**
     * Verify hub by authorizing in it
     */
    /**
     * Zero step. Fill url field with server-provided url.
     */
      then(result => {
        if (result.hubUrl) {
          hubUrl = this.hubSettings[this.fields.HUB_URL] = result.hubUrl;
        }
        return result;
      }).
    /**
     * If Guest is not banned use pop-up authorization
     */
      then(result => {
        if (!this.authWithCredentials) {
          return this.hubAuthPopup(result, LANDING_URL).
            finally(() => {
            }, function notifyCallback() {
              this.hubError = this.i18n('Cannot open Hub authorization pop-up. Please check that your browser does not block pop-ups on this site');
            }.bind(this)).

            // after user press Trust button in Popup make request to verify this service

            then(accessToken => {
              this.hubError = null;
              const clearTailSlash = url => url.replace(/\/$/, '');
              // eslint-disable-next-line new-cap
              const hubServiceResource = this.HubResourceFactory(clearTailSlash(hubUrl), 'services', accessToken).authorizedGet({
                id: hubStateResource.serviceId,
                fields: 'name,applicationName,verified'
              });

              return hubServiceResource.$promise.then(() => {
                hubServiceResource.trusted = true;
                return hubServiceResource.$authorizedUpdate({
                  id: hubStateResource.serviceId
                });
              });
            });
        }
      }).
    /**
     * Third step: update service info from backend (service must become verified)
     */
      then(() => hubStateResource.$get()).
      then(() => {
        hubUrl = this.hubSettings[this.fields.HUB_URL];
      }).
    /**
     * Catch errors
     */
      catch(error => {
        const data = error.data || {};
        this.hubError = data && data.error_description ||
          data && data.errors && (data.errors.hubUrl || (data.errors[0] && data.errors[0].error_description)) ||
          data.error ||
          error;


        // Custom error messages for some cases
        if (error.status === 403 && this.hubError.indexOf('Operation UPDATE for Service') > -1) {
          this.hubError = this.i18n(
            'The user you logged in has no permissions to update services in Hub. ' +
            'Either grant him "Update Service" permission or log in as another user.'
          );
        }

        return this.$q.reject();
      }).
    /**
     * Last step: display result
     */
      then(() => {
        this.isVerified = hubStateResource[this.fields.VERIFIED];
        this.hubHomeUrl = hubStateResource[this.fields.HUB_HOME_URL];
        this.hubHomeUrlIsAvailable = hubStateResource[this.fields.HUB_HOME_URL_IS_AVAILABLE];
      });

  }
}



// WEBPACK FOOTER //
// ./src/pages/hub-settings/hub-settings__controller.js